import { create } from 'zustand';

interface AppState {
  sidebarOpen: boolean;
  currentModule: string;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  setCurrentModule: (module: string) => void;
}

export const useAppStore = create<AppState>((set) => ({
  sidebarOpen: false,
  currentModule: 'dashboard',
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setSidebarOpen: (open: boolean) => set({ sidebarOpen: open }),
  setCurrentModule: (module: string) => set({ currentModule: module }),
}));